export const FETCH_TIME_START = "FETCH_TIME_START";
export const FETCH_TIME_SUCCESS = "FETCH_TIME_SUCCESS";
export const FETCH_TIME_FAIL = "FETCH_TIME_FAIL";
